/**
 * Format a duration between an ISO date and now as a compact human string.
 * Examples: "2h", "1d 4h", "12m", "just now"
 */
export function formatAge(iso, nowMs = Date.now()) {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return "—";
  let diff = Math.max(0, Math.floor((nowMs - t) / 1000)); // seconds
  if (diff < 60) return "just now";
  const m = Math.floor(diff / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const remM = m % 60;
  if (h < 24) return remM ? `${h}h ${remM}m` : `${h}h`;
  const d = Math.floor(h / 24);
  const remH = h % 24;
  return remH ? `${d}d ${remH}h` : `${d}d`;
}

const OPEN_STATUSES = new Set(["Received", "Assigned", "In Progress"]);

export function isUrgentOpen(ticket) {
  return ticket?.priority === "Urgent" && OPEN_STATUSES.has(ticket?.status);
}

export function isOpen(ticket) {
  return OPEN_STATUSES.has(ticket?.status);
}
